import PropTypes from 'prop-types';
import React from 'react';
import en from '../../intl/translations/en';

const ActionLink = ({ href, onClickPaywall }) => (
  <a href={href} onClick={onClickPaywall}>
    {en.premiumCTA.ForecastVisualizerCTA.linkText}
  </a>
);

ActionLink.propTypes = {
  href: PropTypes.string,
  onClickPaywall: PropTypes.func,
};

ActionLink.defaultProps = {
  href: null,
  onClickPaywall: null,
};

export default ActionLink;
